import { OnboardingLayout } from '@features/onboarding/components/OnboardingLayout';
import { Step1CreateAccount } from '@features/onboarding/steps/Step1CreateAccount';
import { Step2BusinessProfile } from '@features/onboarding/steps/Step2BusinessProfile';
import { Step3Services } from '@features/onboarding/steps/Step3Services';
import { Step4Schedule } from '@features/onboarding/steps/Step4Schedule';
import { Step5Done } from '@features/onboarding/steps/Step5Done';
import { useBusinessSettingsStore } from '@features/onboarding/store/businessSettingsStore';

export function OnboardingPage() {
  const { currentStep, setStep } = useBusinessSettingsStore();

  function next() {
    setStep(Math.min(currentStep + 1, 5));
  }

  function back() {
    setStep(Math.max(currentStep - 1, 1));
  }

  return (
    <OnboardingLayout currentStep={currentStep} wide={currentStep === 4}>
      {currentStep === 1 && <Step1CreateAccount onNext={next} />}
      {currentStep === 2 && <Step2BusinessProfile onNext={next} onBack={back} />}
      {currentStep === 3 && <Step3Services onNext={next} onBack={back} />}
      {currentStep === 4 && <Step4Schedule onNext={next} onBack={back} />}
      {currentStep === 5 && <Step5Done />}
    </OnboardingLayout>
  );
}
